var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"frv2-pdfe-page"},[_c('PDFRenderer',{attrs:{"cards":_vm.cards,"config":_vm.config,"metadata":_vm.metadata},on:{"select":_vm.onSelectCard}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }